import { Link } from 'react-router-dom';

export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/5390af1b9222ae6e92dc7da25193e2e6/65a0e09d2eafecea725f43c7f76a00d5.png" 
                  alt="STI Logo" 
                  title="Servicio Técnico Informático"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <span className="text-xl font-semibold">Servicio Técnico IT</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Soluciones integrales de <strong className="text-gray-300">soporte técnico informático</strong> en Capital Federal y Zona Norte.
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6 text-neon-400">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Soporte Técnico
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Infraestructura y Redes
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Seguridad Informática
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Consultoría IT
                </button>
              </li>
              <li>
                <Link to="/software-legal" className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Software Legal
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6 text-neon-400">Empresa</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('nosotros')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('cobertura')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Cobertura
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contacto')} className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-6 text-neon-400">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <i className="ri-map-pin-line text-neon-400 mt-0.5"></i>
                <span>Capital Federal y Zona Norte<br />Buenos Aires, Argentina</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-neon-400"></i>
                <a href={`https://wa.me/5491140402887?text=${encodeURIComponent('Me contacto del sitio web STI, mi nombre es: ')}`} target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  +54 9 11 4040-2887
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-neon-400"></i>
                <a href="tel:01140402887" className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
                  011-4040-2887
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="neon-line mt-12 opacity-30"></div>

        <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2024 Servicio Técnico Informático. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-neon-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
